import * as types from "./actionTypes";

// Employee
export const fetchAttendanceEmployeeList = (payload) => ({
  type: types.FETCH_EMPLOYEE_LIST_REQUEST,
  payload,
});

// Leave Type
export const fetchAttendanceLeaveType = (unit_id) => ({
  type: types.FETCH_LEAVE_TYPE_REQUEST,
  payload: { unit_id },
});

// Leave Balance
export const fetchLeaveBalance = (payload) => ({
  type: types.FETCH_LEAVE_BALANCE_REQUEST,
  payload,
});

// Check Leave Exists
export const checkLeaveExists = (payload) => ({
  type: types.CHECK_LEAVE_EXISTS_REQUEST,
  payload,
});

// Week of Dates
export const fetchWeekOfDates = (payload) => ({
  type: types.FETCH_WEEK_OF_DATES_REQUEST,
  payload,
});

export const applyLeaveOrPermissionOrOnduty = (tabName, payload) => ({
  type: types.APPLY_TAB_REQUEST,
  payload,
  tabName,
});

// 🔹 Get Marker Pending List
export const fetchMarkerPendingList = (payload) => ({
  type: types.FETCH_MARKER_PENDING_LIST_REQUEST,
  payload,
});

// 🔹 Approve Marker
export const markerApprove = (payload) => ({
  type: types.MARKER_APPROVE_REQUEST,
  payload,
});

// 🔹 Get Marker Cancel List
export const fetchMarkerCancelList = (payload) => ({
  type: types.FETCH_MARKER_CANCEL_LIST_REQUEST,
  payload,
});

// 🔹 Cancel Marker
export const markerCancel = (payload) => ({
  type: types.MARKER_CANCEL_REQUEST,
  payload,
});

// 🔹 Get Absent List
export const fetchAbsentList = (payload) => ({
  type: types.FETCH_ABSENT_LIST_REQUEST,
  payload,
});

// 🔹 Update LOP
export const absentLopUpdate = (payload) => ({
  type: types.ABSENT_LOP_UPDATE_REQUEST,
  payload,
});

// 🔹 Update Leave
export const absentLeaveUpdate = (payload) => ({
  type: types.ABSENT_LEAVE_UPDATE_REQUEST,
  payload,
});

// 🔹 Update OD
export const absentOdUpdate = (payload) => ({
  type: types.ABSENT_OD_UPDATE_REQUEST,
  payload,
});

// 🔹 Update WeekOff
export const absentWeekOffUpdate = (payload) => ({
  type: types.ABSENT_WEEKOFF_UPDATE_REQUEST,
  payload,
});

export const clearAbsentError = () => ({
  type: "CLEAR_ABSENT_ERROR",
});

// Check Employee Leave Type
export const checkEmployeeLeaveType = (payload) => ({
  type: types.FETCH_EMPLOYEE_LEAVE_TYPE_REQUEST,
  payload,
});
